import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetEditMode } from "@features/profile";

export const useResetEditmode = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.pathname !== "/profile") {
      dispatch(resetEditMode());
    }
  }, [location.pathname, dispatch]);
};
